export default {
  Title: 'Bulk Messaging',
  Subtitle: 'Find recipients by status and incomplete profile categories, then send them a message in batches.',
  Fields: {
    EntityType: 'Entity type',
    Status: 'Status',
    Channel: 'Channel',
    Subject: 'Email subject',
    Message: 'Message',
  },
  EntityTypes: {
    CAREGIVER: 'Caregivers',
    CLIENT: 'Clients',
  },
  Channels: {
    SMS: 'SMS',
    EMAIL: 'Email',
    SUPPORT_CHAT: 'Support chat',
  },
  SenderEmail: {
    Available: 'Sender email: #{email}',
    Missing: 'No sender email is available for your account. Sending is disabled.',
  },
  ProfileCategories: {
    Title: 'Message caregivers with incomplete profile categories',
    Description: 'Caregivers missing any signal in a selected category will be included. Unselected categories are ignored.',
    MissingCategories: 'Incomplete profile categories',
    Clear: 'Clear categories',
    Required: 'Select at least one incomplete category to create the caregiver audience.',
    Matched: '#{matched} of #{total} caregivers in the selected status have at least one selected category incomplete.',
    Options: {
      contact: 'Contact',
      profile: 'Profile',
      experience: 'Experience',
      questionnaire: 'Questionnaire',
      agreement: 'Agreement',
      administrative: 'Administrative',
    },
    Signals: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phoneNumber: 'Phone number',
      streetAddress: 'Street address',
      city: 'City',
      province: 'Province',
      postalCode: 'Postal code',
      profilePhoto: 'Profile photo',
      shortBio: 'Short bio',
      personalBio: 'Personal bio',
      caregiverMotivation: 'Caregiver motivation',
      languages: 'Languages',
      certificates: 'Certificates',
      workHistory: 'Work history',
      references: 'References',
      education: 'Education',
      preferences: 'Preferences',
      availability: 'Availability',
      skillsExperienceCompleted: 'Skills and experience questionnaire',
      personalityCompleted: 'Personality questionnaire',
      termsAgreement: 'Terms agreement',
      certifiesTruthfulness: 'Truthfulness certification',
      understandsPrivacyAndAgreesToConfidentialityPolicies: 'Privacy and confidentiality agreement',
      certifiesValidAndUpToDateCertifications: 'Certification validity agreement',
      understandsAbuseProhibition: 'Abuse prohibition agreement',
      committedToCodeOfConductAndEthics: 'Code of conduct and ethics',
      canadianId: 'Canadian ID',
      canadianIdDocuments: 'Canadian ID documents',
      vulnerableSectorCheck: 'Vulnerable sector check',
      vulnerableSectorCheckDocuments: 'Vulnerable sector check documents',
    },
  },
  Actions: {
    Cancel: 'Cancel',
    ConfirmSend: 'Confirm and send',
    ConfirmDry: 'Confirm dry run',
    RunDry: 'Run dry send',
    Send: 'Send message',
    Stop: 'Stop sending',
  },
  DryRun: {
    Title: 'Dry-run mode',
    Description: 'Uses the complete current recipient list, eligibility checks, page batches, and delays without sending any messages.',
    Active: 'DRY RUN - NOTHING WILL BE SENT',
  },
  Query: {
    Loading: 'Loading every matching page...',
    Loaded: '#{count} recipients loaded for the selected status.',
    Empty: 'No results match the selected status.',
    Failed: 'The recipient query failed. Change the selection to try again.',
    SelectStatus: 'Select a status to load recipients.',
    Preflighting: 'Checking existing support conversations...',
  },
  Table: {
    Name: 'Name',
    ResourceRn: 'Resource RN',
    Status: 'Status',
    Recipient: 'Recipient',
    Contact: 'Contact',
    LatestMessage: 'Latest recorded message',
    Delivery: 'Delivery',
    NoContact: 'No contact available',
    NoMessage: 'No recorded message',
    Direct: 'Direct caregiver contact',
  },
  Delivery: {
    READY: 'Ready',
    SENDING: 'Sending',
    SIMULATING: 'Simulating',
    SENT: 'Sent',
    WOULD_SEND: 'Would send',
    FAILED: 'Failed',
    SKIPPED: 'Skipped',
    CANCELED: 'Not sent',
  },
  FailureReasons: {
    NO_USER_LINK_FOUND: 'No Dialpad link was found for this recipient.',
    NO_USER_EMAIL: 'No notification email is registered for this recipient.',
    SMS_SEND_NOT_CONFIRMED: 'The SMS service did not confirm the send.',
    EMAIL_SEND_NOT_CONFIRMED: 'The email service did not confirm the send.',
    SUPPORT_MESSAGE_NOT_CREATED: 'The support chat message was not recorded.',
    REQUEST_FAILED: 'The send request failed.',
  },
  Sending: {
    InitialDelay: 'Sending begins in #{seconds} seconds. Stop now to prevent every message.',
    ActivePage: 'A recipient batch is currently being processed. Stopping will prevent the next batch.',
    BetweenPages: 'The next recipient batch begins in #{seconds} seconds.',
    CancelRequested: 'Stop requested. The active batch will finish, but no additional batch will start.',
  },
  SkipReasons: {
    MissingPrimaryRelationship: 'No primary relationship',
    MissingEmail: 'Primary relationship has no email address',
    MissingPhone: 'Primary relationship has no phone number',
    MissingCaregiverEmail: 'Caregiver has no email address',
    MissingCaregiverPhone: 'Caregiver has no phone number',
    MissingSupportConversation: 'No existing support conversation',
  },
  Confirmation: {
    Title: 'Confirm bulk message',
    Description: 'This will send to #{eligible} recipients. #{skipped} recipients will be skipped.',
    DryDescription: 'This would send to #{eligible} recipients. #{skipped} recipients would be skipped.',
    EntityType: 'Entity type',
    Status: 'Status',
    Channel: 'Channel',
    SenderEmail: 'Sender email',
    MissingCategories: 'Incomplete categories',
    Subject: 'Subject',
    Message: 'Message',
    DryRun: 'This is a simulation. No notification or support-chat write requests will be made.',
  },
  Summary: {
    Complete: 'Bulk send complete: #{sent} sent, #{failed} failed, #{skipped} skipped.',
    DryComplete: 'Dry run complete: #{sent} messages would be sent and #{skipped} recipients would be skipped. No messages were sent.',
    Canceled: 'Bulk send stopped: #{sent} sent, #{failed} failed, #{canceled} not sent, and #{skipped} skipped.',
    DryCanceled: 'Dry run stopped: #{sent} evaluated as would send, #{canceled} not evaluated, and #{skipped} skipped. No messages were sent.',
  },
};
